import { render, staticRenderFns } from "./WallBrandedFooterBlock.vue?vue&type=template&id=2abf400e"
import script from "./WallBrandedFooterBlock.vue?vue&type=script&lang=js"
export * from "./WallBrandedFooterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports